var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"color-input"},[_c('toolcool-color-picker',{attrs:{"color":_vm.value,"button-padding":"0px","button-width":"20px","button-height":"20px"},on:{"change":function($event){return _vm.$emit('input', $event.detail.hex)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }